import { MantineDataTable } from "@/components/molecule/mantineDataTable/MantineDataTable";
import PageTemplate from "@/components/template/page/PageTemplate";
import { COMMON_TEXT } from "@/constants/text";
import { useProductionPerformanceFetch } from "@/fetch/page/useProductionPerformanceFetch";
import { usePaginationStore } from "@/store/pagenation.store";
import { setToLocaleString } from "@/utils/unitMark";
import { Flex, Pagination } from "@mantine/core";
import { WorksItemGet200ResponseRowsInner } from "@sizlcorp/sizl-api-document/dist/models";
import dayjs from "dayjs";
import { MRT_ColumnDef } from "mantine-react-table";
import { useEffect, useMemo } from "react";

const ProductionPerformance = Object.assign(
  {},
  {
    Template: PageTemplate,
    Table: MantineDataTable,
    Pagination: Pagination,
  }
);

export const ProductionPerformancePage = () => {
  const { data, Fetcher: PerformanceFetcher } = useProductionPerformanceFetch();
  const { currentPage, setPage } = usePaginationStore((state) => ({
    currentPage: state.currentPage,
    setPage: state.setPage,
  }));

  const worksData = data?.data.rows as WorksItemGet200ResponseRowsInner[];
  const totalPages = data?.data.totalPages;

  const convertedData = worksData?.map((work) => ({
    id: work.id,
    itemName: work.itemName ?? "-",
    spec: work.spec ?? "-",
    equipmentName: work.equipmentName ?? "-",
    scheduledAt: work.scheduledAt
      ? dayjs(work.scheduledAt).format("YYYY-MM-DD")
      : "-",
    targetQuantity: `${setToLocaleString(work.targetQuantity)}${work.item?.unitText ?? ""}`,
    performance: `${setToLocaleString(work.summary?.performance)}${work.item?.unitText ?? ""}`,
  }));

  type PerformanceRow = NonNullable<typeof convertedData>[number];

  const columns = useMemo<MRT_ColumnDef<PerformanceRow>[]>(
    () => [
      { accessorKey: "id", header: "작업지시 ID" },
      { accessorKey: "itemName", header: COMMON_TEXT.COLUMN.ITEM_NAME },
      { accessorKey: "spec", header: COMMON_TEXT.COLUMN.SPEC },
      { accessorKey: "equipmentName", header: COMMON_TEXT.COLUMN.EQUIPMENT_NAME },
      { accessorKey: "scheduledAt", header: COMMON_TEXT.COLUMN.SCHEDULED_AT },
      { accessorKey: "targetQuantity", header: COMMON_TEXT.COLUMN.TARGET_QUANTITY },
      { accessorKey: "performance", header: "생산실적 수량" },
    ],
    []
  );

  useEffect(() => {
    setPage(1);
  }, []);

  return (
    <PerformanceFetcher>
      <ProductionPerformance.Template>
        <ProductionPerformance.Table
          columns={columns}
          data={convertedData ?? []}
        />
        <Flex mt={20} justify={"center"}>
          <ProductionPerformance.Pagination
            total={totalPages || 0}
            value={currentPage}
            onChange={(page) => setPage(page)}
          />
        </Flex>
      </ProductionPerformance.Template>
    </PerformanceFetcher>
  );
};
